.button {
    display: flex;
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid var(--static-divider-standard);
    justify-content: center;
    align-items: center;
    background: var(--static-background-standard);
    gap: 8px;
    cursor: pointer;
}

.price {
    font-size: var(--fs-small);
    font-weight: 400;
    line-height: 20px;
    color: var(--static-text-standard);
}

.icon {
    color: var(--static-text-strong);
}